import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { WalletTransferDetails } from '../../../../queries/pxtraCard';
import { InfoIcon } from '../../../icons';

type Props = { details: WalletTransferDetails };

const Line: FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="py-1">
    <p className="m-0 text-sm text-grey-500">{label}</p>
    <p className="m-0 break-words text-base text-primary-main">{value || '–'}</p>
  </div>
);

/** Where to send money so the pool picks it up; hidden until the account has an IBAN. */
export const TransferDetailsBox: FC<Props> = ({ details }) => {
  const { t } = useTranslation();
  if (!details.iban) return null;

  return (
    <div className="mt-4 rounded-2xl bg-white p-4" data-testid="transfer-details">
      <Line label={t('pxtraCard:transferRecipient')} value={details.recipient} />
      <Line label={t('pxtraCard:transferIban')} value={details.iban} />
      <Line label={t('pxtraCard:transferBic')} value={details.bic} />
      <div className="mt-1 border-0 border-t border-solid border-grey-100 pt-1">
        <Line label={t('pxtraCard:transferReference')} value={details.reference} />
      </div>
      <div className="mt-1 flex gap-2 border-0 border-t border-solid border-grey-100 pt-2 text-grey-500">
        <InfoIcon width={14} height={14} className="mt-px shrink-0" />
        <span className="text-xs">{t('pxtraCard:transferReferenceHint')}</span>
      </div>
    </div>
  );
};
